export default "__VITE_ASSET__yyfYUjDN__"